import {
  API_ROUTES,
  type Beacon,
  type BeaconWriteRequest,
  type TechnicalObject,
  type TechnicalObjectListResponse,
} from '@oscom/shared';
import { apiGet } from './client';
import { jsonInit, sendAndUnwrap } from './send';

/** Error wording belongs to the API; only the generic fallback verb lives in the write calls. */
export function listTechnicalObjects(customerId: string): Promise<TechnicalObjectListResponse> {
  return apiGet<TechnicalObjectListResponse>(API_ROUTES.customerTechnicalObjects(customerId));
}

function objectUrl(customerId: string, objectId: string): string {
  return `${API_ROUTES.customerTechnicalObjects(customerId)}/${encodeURIComponent(objectId)}`;
}

export async function createBeacon(
  customerId: string,
  write: BeaconWriteRequest,
): Promise<TechnicalObject> {
  const response = await sendAndUnwrap(
    API_ROUTES.customerTechnicalObjects(customerId),
    jsonInit('POST', write),
    'Speichern',
  );
  return (await response.json()) as TechnicalObject;
}

export async function saveBeacon(
  customerId: string,
  objectId: string,
  write: BeaconWriteRequest,
): Promise<Beacon> {
  const response = await sendAndUnwrap(
    objectUrl(customerId, objectId),
    jsonInit('PUT', write),
    'Speichern',
  );
  return (await response.json()) as Beacon;
}

export async function deleteTechnicalObject(customerId: string, objectId: string): Promise<void> {
  await sendAndUnwrap(objectUrl(customerId, objectId), { method: 'DELETE' }, 'Löschen');
}
